export default __webpack_public_path__ + "static/538-579665a4518345799e72f36351ac2cf7.gif";